import { Skeleton } from '@getgo/chameleon-web-react-wrapper/register';
import { ReactElement } from 'react';

function TextCellSkeleton({ width }: { readonly width?: number }): ReactElement {
  return <Skeleton variant="rectangle" size="xsmall" width={width} />;
}

export default TextCellSkeleton;
